import {makeThemeProps} from "src/themes/utils";

export default (theme, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getProductListProps(theme, site);
};

export const noResultsPlaceholderStyles = (theme, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getNoResultsPlaceholderProps(theme);
};
